import { render, staticRenderFns } from "./BezierCurve.vue?vue&type=template&id=17b7b182&scoped=true&"
import script from "./BezierCurve.vue?vue&type=script&lang=js&"
export * from "./BezierCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b7b182",
  null
  
)

export default component.exports